import Service from "../Service";

const resource = "vehicle/";

export default {
  save(veh, requestID) {
    return Service.post(resource + "save", veh, {
      params: { requestID: requestID },
    });
  },
  saveCircuit(veh, AccID, requestID) {
    return Service.post(resource + "MngGenerateCircuit", veh, {
      params: { requestID, AccID },
    });
  },
  approved(objTransaction, requestID) {
    return Service.post(resource + "MngApprovalTransactionApproved", objTransaction, {
      params: { requestID },
    });
  },
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID: requestID },
    });
  },
  list(filter, requestID) {
    return Service.post(resource + "list", filter, {
      params: { requestID: requestID },
    });
  },
  listURL() {
    return resource + "list";
  },
  get(veh, requestID) {
    return Service.post(resource, veh, {
      params: { requestID: requestID },
    });
  },
  excel(cmp, requestID) {
    return Service.post(resource + "reportexcel", cmp, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  SearchVehPlate(obj, requestID) {
    return Service.post(resource + "searchvehplate", obj, {
      params: { requestID: requestID },
    });
  },
  verifyVehSoat(params, requestID) {
    return Service.post(resource + "verifysoat", params, {
      params: { ...params, requestID },
    });
  },
};
